import {ChangeDetectionStrategy, Component, inject, OnInit} from '@angular/core';
import {HeaderComponent} from "../../core/components/header/header.component";
import {I18NextPipe} from "@kokos-i18next";
import {PagesEnum} from "../../core/model/pages.enum";
import {HinweisboxTypeEnum} from "../../shared/components/hinweisbox/hinweisbox-type.enum";
import {HinweisboxComponent} from "../../shared/components/hinweisbox/hinweisbox.component";
import {FooterComponent} from "../../shared/components/footer/footer.component";
import i18next from "i18next";
import {FooterButton, FooterButtonType} from "../../shared/components/footer/footer-button";
import {NavigationService} from "../../shared/utils/navigation.service";
import {environment} from "../../../environments/environment";
import {NachrichtSuccessType} from "../nachricht-success-type.enum";
import {RedirectService} from "../../core/services/redirect.service";
import {ActivatedRoute} from "@angular/router";


@Component({
    selector: 'kokos-nachricht-success',
    imports: [
        HeaderComponent,
        I18NextPipe,
        HinweisboxComponent,
        FooterComponent
    ],
    templateUrl: './nachricht-success.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
})
export class NachrichtSuccessComponent implements OnInit {


    protected readonly NachrichtSuccessType = NachrichtSuccessType;

    protected readonly PagesEnum = PagesEnum;
    protected readonly HinweisboxTypeEnum = HinweisboxTypeEnum;


    private readonly nav = inject(NavigationService);
    private readonly redirectService = inject(RedirectService);
    private readonly route = inject(ActivatedRoute);

    nachrichtSuccessType: NachrichtSuccessType = NachrichtSuccessType.SENT;
    redirectUrl: string;


    ngOnInit(): void {
        const raw = this.route.snapshot.paramMap.get('successType');

        if (Object.values(NachrichtSuccessType).includes(raw as NachrichtSuccessType)) {
            this.nachrichtSuccessType = raw as NachrichtSuccessType;
        }

        this.redirectUrl = this.redirectService.redirectUrl;
    }

    get backButtonConfig(): FooterButton {
        return {
            label: i18next.t('navigation.profile'),
            type: FooterButtonType.back,
        };
    };

    get forwardButtonConfig(): FooterButton {
        return {
            label: this.redirectUrl ? i18next.t('navigation.forward') : i18next.t('navigation.inbox'),
            type: FooterButtonType.forward,
        };
    };

    handleForwardClicked(): void {
        if (this.redirectUrl) {
            globalThis.location.href = this.redirectUrl;
        } else {
            this.nav.goTo('/');
        }
    }

    handleBackClicked(): void {
        globalThis.location.href = environment.profilUrl;
    }

}
